import { Alert } from 'avo-ui'
import { BrandWinner } from 'components/award/award-winner/brand-winner/BrandWinner'
import { useEffect, useState } from 'react'
import { API_AWARD } from 'services/apiAward'
import { METHOD } from 'services/method'
import { useFetch } from 'services/useFetch'
import { uploadFileToS3 } from 'utils/utils'

const INITIAL_STATE = {
    is_show: false,
    desktop_background: null,
    mobile_background: null,
    brands: [
        {
            image_url: null,
            title: null,
        },
    ],
}

export const BrandWinnerContainer = () => {
    const [brandDetail, setBrandDetail] = useState(INITIAL_STATE)
    const copyItems = [...(brandDetail?.brands || [])]
    const [errorForm, setErrorForm] = useState({})
    const [isLoadingUpload, setLoadingUpload] = useState(false)
    const { fetching: getBrand, isLoading } = useFetch(API_AWARD.WINNER_BRAND)
    const { fetching: updateBrand, isLoading: isUpdating } = useFetch({
        ...API_AWARD.WINNER_BRAND,
        method: METHOD.PUT,
    })
    const { fetching: getURLImage } = useFetch(API_AWARD.URL_AWARD_IMAGE)

    useEffect(() => {
        fetchBrand()
    }, [])

    const fetchBrand = async () => {
        const response = await getBrand()
        let responseData = response?.data

        if (response?.data?.brands?.length === 0) {
            responseData = {
                ...responseData,
                brands: [
                    {
                        image_url: null,
                        title: null,
                    },
                ],
            }
        }
        setBrandDetail(responseData)
    }

    const onChangeForm = (e) => {
        const { name, value } = e
        setBrandDetail({ ...brandDetail, [name]: value })
    }

    const setItems = (items) => {
        setBrandDetail({ ...brandDetail, brands: items })
    }

    const onChangeItem = (e) => {
        const { name, value, index } = e
        copyItems[index][name] = value
        setItems(copyItems)
    }

    const onAddNewItem = () => {
        setItems([
            ...copyItems,
            {
                image_url: null,
                title: null,
            },
        ])
    }

    const handleUploadImage = async (files) => {
        try {
            let newFormImage = {}
            if (files?.desktop_background || files?.mobile_background) {
                const fileNames = Object.entries(files)
                    .map(([key, item]) => item.name)
                    .filter((item) => item)

                const s3Urls = await getURLImage({ files: fileNames })

                const newEntries = Object.entries(files).reduce((acc, [key, item], index) => {
                    if (key === 'brands') return acc
                    acc.push([key, { ...item, ...s3Urls?.data?.[index] }])
                    return acc
                }, [])

                const s3UrlsWithKey = Object.fromEntries(newEntries)
                await Promise.all(
                    Object.entries(s3UrlsWithKey).map(async ([key, item], index) => {
                        await uploadFileToS3(item, item.file)
                        newFormImage = {
                            ...newFormImage,
                            [key]: `${s3UrlsWithKey?.[key]?.url}${s3UrlsWithKey?.[key]?.fields?.key}`,
                        }
                    }),
                )
            }

            if (files?.brands?.length > 0) {
                let newFiles = []
                const fileNames = files?.brands.map((item) => item.image_url.name)
                const s3Urls = await getURLImage({ files: fileNames })

                await Promise.all(
                    s3Urls?.data?.map(async (item, index) => {
                        const itemFile = { image_url: '', currentIndex: '' }
                        await uploadFileToS3(item, files?.brands[index]?.image_url?.file)
                        itemFile.image_url = `${item?.url}${item?.fields?.key}`
                        itemFile.currentIndex = files?.brands[index]?.currentIndex
                        newFiles.push(itemFile)
                    }),
                )
                newFormImage = { ...newFormImage, brands: [...newFiles] }
            }

            return newFormImage
        } catch {
            setLoadingUpload(false)
        }
    }

    const validationForm = () => {
        const newErrorForm = { ...errorForm }
        if (!brandDetail.desktop_background) {
            newErrorForm.desktop_background = 'Background desktop wajib diisi'
        } else {
            newErrorForm.desktop_background = ''
        }

        if (!brandDetail.mobile_background) {
            newErrorForm.mobile_background = 'Background mobile wajib diisi'
        } else {
            newErrorForm.mobile_background = ''
        }

        const errorArrayItem = []
        for (const item of brandDetail.brands) {
            const itemError = { image_url: '', title: '' }
            if (!item.image_url) itemError.image_url = 'Brand image wajib diisi'
            if (!item.title) itemError.title = 'Title wajib diisi'
            errorArrayItem.push(itemError)
        }
        newErrorForm.brands = [...errorArrayItem]

        return newErrorForm
    }

    const isValid = (data) => {
        if (typeof data === 'string') {
            return data === ''
        }
        if (Array.isArray(data)) {
            return data.every(isValid)
        }
        if (typeof data === 'object' && data !== null) {
            return Object.values(data).every(isValid)
        }
        return false
    }

    const onSubmit = async () => {
        const findErrors = validationForm()
        setErrorForm(findErrors)
        if (!isValid(findErrors)) return

        let files = {}
        if (brandDetail?.desktop_background?.file)
            files = { ...files, desktop_background: brandDetail?.desktop_background }
        if (brandDetail?.mobile_background?.file)
            files = { ...files, mobile_background: brandDetail?.mobile_background }

        let payload = { ...brandDetail }

        const fileArray = brandDetail.brands
            .map((item, index) => ({ ...item, currentIndex: index }))
            .filter((item) => item?.image_url?.file)

        if (fileArray.length > 0) {
            files = { ...files, brands: fileArray }
        }

        if (Object.entries(files).length > 0) {
            setLoadingUpload(true)
            const filePayload = await handleUploadImage(files)
            payload = {
                ...payload,
                ...(filePayload?.desktop_background && { desktop_background: filePayload?.desktop_background }),
                ...(filePayload?.mobile_background && { mobile_background: filePayload?.mobile_background }),
            }

            if (filePayload?.brands?.length > 0) {
                for (const itemFile of filePayload?.brands) {
                    payload.brands[itemFile?.currentIndex].image_url = itemFile?.image_url
                }
            }
            setLoadingUpload(false)
        }

        await updateBrand(payload)
        await fetchBrand()
        Alert({
            icon: 'success',
            title: 'Success',
            message: 'Brand Section Updated!',
        })
    }

    const props = {
        data: brandDetail,
        items: copyItems,
        setItems,
        onChangeForm,
        onChangeItem,
        onAddNewItem,
        errorForm,
        isLoadingUpload,
        isLoading,
        isUpdating,
        onSubmit,
    }

    return <BrandWinner {...props} />
}
